<div class="flex flex-col pt-4 space-y-4">
  <app-section-header
    [title]="pageHeader"
    [isBackBtnShown]="true"
    [backRoute]="['/dashboard']"
  >
    <app-content-state-controls
      *ngIf="initialContentSetContent"
      [allowableNextStates]="
        initialContentSetContent.dynamicData.allowableNextStates
      "
      [isProcessingStateChange]="isProcessingStateChange"
      [isPublished]="initialContentSetContent.isPublished()"
      [isSpiked]="initialContentSetContent.isSpiked"
      [form]="form"
      [isSaving]="isSaving"
      (handleStateChange)="onUpdateState($event)"
      (handleReEditClick)="onCreateNewVersion()"
      (handleReactivateClick)="onReactivateContentSet()"
    ></app-content-state-controls>
  </app-section-header>
  <ng-container *ngIf="isProcessing || initialContentSetContent">
    <app-processing-boundary
      [isProcessing]="isProcessing || !initialContentSetContent"
      [processingMsg]="'Loading...'"
    >
      <div *ngIf="initialContentSetContent">
        <app-content-status-card
          [form]="form"
          [formReady]="formReady.asObservable()"
          [content]="initialContentSetContent"
          [isSaving]="isSaving"
          (handleSave)="onSave()"
          class="px-4"
        ></app-content-status-card>
        <app-content-status-message
          [content]="initialContentSetContent"
          [contentType]="CONTENT_TYPES.CONTENT_SET"
        ></app-content-status-message>
      </div>
      <form
        class="flex p-4 space-x-4"
        (keydown.enter)="$event.preventDefault()"
        [formGroup]="form"
        *ngIf="initialContentSetContent"
      >
        <div class="flex flex-col flex-1 min-w-0 space-y-4">
          <div class="flex flex-row flex-1 space-x-1">
            <div class="basis-1/2">
              <app-text-input
                class="large-text"
                [control]="form.get(FORM_PATHS.CONTENT_SET_HEADLINE())"
                [name]="'Title'"
                [placeholder]="'Title'"
                [boldFont]="true"
              >
              </app-text-input>
            </div>
            <div class="basis-1/2">
              <app-text-input
                class="large-text"
                [control]="form.get(FORM_PATHS.STRAPLINE())"
                [name]="'Strapline'"
                [placeholder]="'Strapline'"
                [boldFont]="true"
              >
              </app-text-input>
            </div>
          </div>
          <app-text-input
            class="large-text"
            [control]="form.get(FORM_PATHS.HEADLINE())"
            [name]="'Name'"
            [placeholder]="'Name'"
            [boldFont]="true"
          >
          </app-text-input>
          <app-media-adder
            [sectionImgsFormControl]="form.get(FORM_PATHS.BANNER_IMAGE())"
            [isMainMedia]="true"
            [mainMediaLabel]="'Banner Image'"
            [addMediaLabel]="'Banner'"
            [isDisabled]="!isEditMode"
          >
          </app-media-adder>
          <app-media-adder-condensed
            [sectionImgsFormControl]="form.get(FORM_PATHS.SPONSOR_LOGOS())"
            [cardTitle]="'Sponsor Logos'"
            [addMediaLabel]="'Add logos'"
            [isDisabled]="!isEditMode"
          >
          </app-media-adder-condensed>
          <app-media-adder
            [sectionImgsFormControl]="form.get(FORM_PATHS.MAIN_IMAGE())"
            [displayImageOnWebsiteControl]="
              form.get(FORM_PATHS.DISPLAY_IMAGE_ON_WEBSITE())
            "
            [isMainMedia]="true"
            [mainMediaLabel]="'Social media image'"
            [addMediaLabel]="'Social media'"
            [isDisabled]="!isEditMode"
          >
          </app-media-adder>
          <app-text-input
            [control]="form.get(FORM_PATHS.LANDING_PAGE_HEADLINE())"
            [name]="'Headline'"
            [placeholder]="'Headline'"
            [boldFont]="true"
          >
          </app-text-input>
          <app-content-editor
            *ngIf="!isProcessing"
            [sectionFormControl]="form.get(FORM_PATHS.BODY())"
            [sectionImgsFormControl]="form.get(FORM_PATHS.IMGS())"
            [sectionVideosFormControl]="form.get(FORM_PATHS.VIDEOS())"
            [isDisabled]="!isEditMode"
          ></app-content-editor>
          <app-chapters
            *ngIf="form.get(FORM_PATHS.WEBSITES())?.value"
            [chapterControl]="form.get(FORM_PATHS.CHAPTERS())"
            [editions]="_buildDeliveryTargetCodes()"
            [isDisabled]="!isEditMode"
          ></app-chapters>
        </div>
        <div class="flex flex-1 min-w-0 pt-1.5 mt-2">
          <mat-accordion [multi]="false" class="flex flex-1 space-x-3">
            <div class="flex flex-col w-1/2 space-y-3 basis-1/2">
              <app-colour-picker
                [control]="form.get(FORM_PATHS.PRIMARY_COLOUR_HEX())"
              ></app-colour-picker>
              <app-expandable-checkbox-list
                [iconClass]="'icon-globe'"
                [title]="'Websites'"
                [formGroup]="form.get(FORM_PATHS.WEBSITES())"
                [metadata]="deliveryTargets$ | async"
                [isExpandedByDefault]="isNewContentSet"
                [isExpandable]="isEditMode"
                (onItemChecked)="onEditionAdded($event)"
                (onItemUnchecked)="onEditionRemoved($event)"
              ></app-expandable-checkbox-list>
              <app-surtitles
                [surtitleControl]="form.get(FORM_PATHS.SURTITLES())"
                [tagControl]="form.get(FORM_PATHS.TAGS())"
                [typedTags]="form.get(FORM_PATHS.TYPED_TAGS())"
                [currentEditionLanguage]="
                  form.get(FORM_PATHS.EDITION_LANGUAGE())
                "
                [detailedTopicList]="
                  form.get(FORM_PATHS.TOPICS_WITH_TRANSLATIONS())
                "
                [isExpandedByDefault]="false"
                [isExpandable]="isEditMode"
                (handleAddToBody)="onAddToBody($event)"
                (handleRemoveLink)="onRemoveLink($event)"
              >
              </app-surtitles>
              <app-tagging
                [topicControl]="form.get(FORM_PATHS.TOPICS())"
                [tagControl]="form.get(FORM_PATHS.TAGS())"
                [companyControl]="form.get(FORM_PATHS.COMPANIES())"
                [peopleControl]="form.get(FORM_PATHS.PEOPLE())"
                [websites]="_buildDeliveryTargetCodes()"
                [isExpandedByDefault]="false"
                [isExpandable]="isEditMode"
                [isShowingPeopleAndCompanies]="false"
                [isShowingSurtitles]="true"
                (handleAddToBody)="onAddToBody($event)"
                (handleRemoveLink)="onRemoveLink($event)"
                (handleItemSelected)="onTagItemSelected($event)"
                (handleItemRemoved)="onTagItemRemoved($event)"
                (handleSurtitlePromoted)="onSurtitlePromoted($event)"
              ></app-tagging>
            </div>
            <div class="flex flex-col w-1/2 space-y-3 basis-1/2">
              <app-publish-time
                [publishTimeControl]="form.get(FORM_PATHS.PUBLISH_TIME())"
                [timezoneControl]="form.get(FORM_PATHS.TIMEZONE())"
                [showPublishTimeControl]="
                  form.get(FORM_PATHS.SHOW_PUBLISH_TIME())
                "
                [isExpandedByDefault]="false"
                [isExpandable]="isEditMode"
                [timezones]="timezones"
              ></app-publish-time>
              <app-authors
                id="formSectionAuthors"
                data-testid="formSectionAuthors"
                [isExpandedByDefault]="false"
                [isExpandable]="isEditMode"
                [selectedAuthors]="form.get(FORM_PATHS.SELECTED_AUTHORS())"
                [searchedAuthor]="searchedAuthor"
                [authorList]="authorList"
                [searchList]="searchList"
              ></app-authors>
              <app-expandable-dropdown
                id="formFieldBodyLanguage"
                [iconClass]="'icon-language'"
                [title]="'Language'"
                [sectionFormControl]="form.get(FORM_PATHS.LANGUAGE())"
                [labelKey]="'FriendlyName'"
                [options]="languages$ | async"
                [defaultOption]="DEFAULT_LANGUAGE_OPTION"
                [isExpandedByDefault]="false"
                [isExpandable]="isEditMode"
              ></app-expandable-dropdown>
              <app-visibility
                id="formSectionVisibility"
                data-testid="formSectionVisibility"
                [isExpandedByDefault]="false"
                [isExpandable]="isEditMode"
                [restrictToRegisteredUsersControl]="
                  form.get(FORM_PATHS.RESTRICTED_TO_REGISTERED_USERS())
                "
                [notForGoogleNewsSitemapsControl]="
                  form.get(FORM_PATHS.NOT_FOR_GOOGLE_NEWS_SITEMAPS())
                "
                [notForNewsFeedsControl]="
                  form.get(FORM_PATHS.NOT_FOR_NEWS_FEED())
                "
                [hideThisArticleControl]="
                  form.get(FORM_PATHS.HIDE_THIS_ARTICLE())
                "
                [paywallPremiumContent]="
                  form.get(FORM_PATHS.PAYWALL_PREMIUM_CONTENT())
                "
                [notForCompetitors]="form.get(FORM_PATHS.NOT_FOR_COMPETITORS())"
              ></app-visibility>
              <app-internal-information
                [urls]="initialContentSetContent.dynamicData.liveUrls"
                [contentId]="initialContentSetContent.contentId"
                [isExpandedByDefault]="false"
              ></app-internal-information>
              <app-version-list
                [versions]="initialContentSetContent.dynamicData.versions"
                [articleId]="initialContentSetContent.id"
                [latestPublishedVersionId]="
                  initialContentSetContent.dynamicData.latestPublishedVersionId
                "
                [latestVersionId]="
                  initialContentSetContent.dynamicData.latestVersionId
                "
                [isExpandedByDefault]="false"
                [contentType]="CONTENT_TYPES.CONTENT_SET"
              ></app-version-list>

              <button
                mat-button
                type="button"
                class="h-8 text-xs font-semibold bg-project-4500/60 text-project-300"
                *ngIf="
                  !initialContentSetContent.isPublished() &&
                  initialContentSetContent.dynamicData.versions.length > 1
                "
                (click)="deleteUnpublishedDraft()"
                [disabled]="isProcessingStateChange || isSaving"
                mat-raised-button
                data-testid="deleteUnpublishedButton"
              >
                Delete Unpublished Draft
              </button>
              <button
                mat-button
                class="h-8 text-xs font-semibold bg-project-4500/60 text-project-300"
                *ngIf="!isNewContentSet"
                (click)="deleteContentSet()"
                [disabled]="isProcessingStateChange || isSaving"
                mat-raised-button
                data-testid="deleteButton"
              >
                Delete Content Set
              </button>
              <button
                mat-button
                type="button"
                class="h-8 text-xs font-semibold bg-project-4500/60 text-project-300"
                *ngIf="
                  initialContentSetContent.isPublished() &&
                  !initialContentSetContent.isSpiked &&
                  initialContentSetContent.dynamicData
                    .latestPublishedVersionId === initialContentSetContent.id
                "
                (click)="spikeContentSet()"
                mat-raised-button
                data-testid="spikeButton"
              >
                Spike
              </button>
            </div>
          </mat-accordion>
        </div>
      </form>
    </app-processing-boundary>
  </ng-container>
</div>
